import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/report-leave-initial-balances',
    name: 'report-leave-initial-balance',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/report-leave-initial-balance/index.vue')
  }
]
